export class UpdatePlannedFollowup {
  id: number;
  memberId: number;
  activity: number;
  activityStr: string;
  planDate: Date;
  actualDate: Date;
  status: number;
  assigner: number;
  assignerComment: string;
  assignee: number;
  assigneeComment: string;
  createdBy: string;
  creationDate: Date;
}
